// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@stoneage/Overrides/Components/Carousel";
import { css } from "styled-components";

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
    `,
};
